// @ts-ignore
import idleTimeout from 'idle-timeout';

// @ts-ignore
import IdleTimeout from 'idle-timeout/dist/IdleTimeout';

import { OidcSession } from './oidc/oidc-session';
import { BasicAuthSession } from './basic-auth/basic-auth-session';

import { env_vars } from '../load-env';

export enum SessionType {
    OIDC = 'sessionType_oidc',
    BASIC_AUTH = 'sessionType_basic',
}

export type ReadyChangeCallback =
    (ready: boolean) => void;

export interface Session {
    start: (params?: any) => Promise<boolean>;

    end: () => void;

    signin: (params?: any) => Promise<void>;

    isValid: () => boolean;

    isReady: () => boolean;

    addReadyChangeListener: (
        readyCallback: ReadyChangeCallback,
    ) => void;
}

export class SessionManager {
    static session: Session;

    static sessionType: SessionType;

    private static idleTimer: IdleTimeout;

    static async createSession(
        sessionType: SessionType,
    ) {
        this.sessionType =
            sessionType || SessionType.OIDC;

        switch (this.sessionType) {
            case SessionType.BASIC_AUTH:
                this.session =
                    new BasicAuthSession();
                break;

            case SessionType.OIDC:
            default:
                this.session =
                    new OidcSession();
                break;
        }

        this.session.addReadyChangeListener(() => {
            if (this.idleTimer) {
                this.idleTimer.destroy();
            }

            this.idleTimer = idleTimeout(
                () => {
                    console.log(
                        'Session timed out',
                    );

                    this.endSession();
                },
                {
                    element: document,
                    timeout: Number(
                        env_vars.SESSION_TIMEOUT_MS,
                    ),
                    loop: false,
                },
            );
        });

        return this.session;
    }

    static endSession() {
        if (this.idleTimer) {
            this.idleTimer.destroy();
        }

        if (this.session) {
            this.session.end();
        }

        // @ts-ignore
        delete this.session;

        // @ts-ignore
        delete this.sessionType;
    }

    static hasValidSession() {
        return !!(
            this.session &&
            this.session.isValid()
        );
    }
}
